<template>
  <open-banking-description-step class="obk-description-no-incognito-step" :step-number="stepNumber">
    <template v-slot:text>
      <div>כדאי לשים שהדפדפן במצב רגיל (לא /גלישה פרטית incognito)</div>
    </template>
  </open-banking-description-step>
</template>

<script>
import OpenBankingDescriptionStep from '@/base-components/onboarding/openBanking/OpenBankingDescriptionStep';

export default {
  name: 'ObkDescriptionNoIncognitoStep',
  components: {
    OpenBankingDescriptionStep,
  },
  props: {
    stepNumber: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
